/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brand_AccentInputs */

const en_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const es_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const de_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const zh_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫`)
};

const ar_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const fr_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const vi_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const sw_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const th_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กอล์ฟ`)
};

const bs_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const ja_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフ`)
};

const ko_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프`)
};

const pt_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfe`)
};

const it_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const sv_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const nl_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const da_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const nb_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const fi_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const pl_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const ru_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`гольф`)
};

const tr_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const hi_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल्फ`)
};

const id_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const ms_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const cs_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const el_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γκολφ`)
};

const he_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גולף`)
};

const af_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

const hu_home_brand_accent = /** @type {(inputs: Home_Brand_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf`)
};

/**
* | output |
* | --- |
* | "Golf" |
*
* @param {Home_Brand_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_brand_accent = /** @type {((inputs?: Home_Brand_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brand_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_brand_accent(inputs)
	if (locale === "de") return de_home_brand_accent(inputs)
	if (locale === "zh") return zh_home_brand_accent(inputs)
	if (locale === "ar") return ar_home_brand_accent(inputs)
	if (locale === "fr") return fr_home_brand_accent(inputs)
	if (locale === "vi") return vi_home_brand_accent(inputs)
	if (locale === "sw") return sw_home_brand_accent(inputs)
	if (locale === "th") return th_home_brand_accent(inputs)
	if (locale === "bs") return bs_home_brand_accent(inputs)
	if (locale === "ja") return ja_home_brand_accent(inputs)
	if (locale === "ko") return ko_home_brand_accent(inputs)
	if (locale === "pt") return pt_home_brand_accent(inputs)
	if (locale === "it") return it_home_brand_accent(inputs)
	if (locale === "sv") return sv_home_brand_accent(inputs)
	if (locale === "nl") return nl_home_brand_accent(inputs)
	if (locale === "da") return da_home_brand_accent(inputs)
	if (locale === "nb") return nb_home_brand_accent(inputs)
	if (locale === "fi") return fi_home_brand_accent(inputs)
	if (locale === "pl") return pl_home_brand_accent(inputs)
	if (locale === "ru") return ru_home_brand_accent(inputs)
	if (locale === "tr") return tr_home_brand_accent(inputs)
	if (locale === "hi") return hi_home_brand_accent(inputs)
	if (locale === "id") return id_home_brand_accent(inputs)
	if (locale === "ms") return ms_home_brand_accent(inputs)
	if (locale === "cs") return cs_home_brand_accent(inputs)
	if (locale === "el") return el_home_brand_accent(inputs)
	if (locale === "he") return he_home_brand_accent(inputs)
	if (locale === "af") return af_home_brand_accent(inputs)
	if (locale === "hu") return hu_home_brand_accent(inputs)
	return en_home_brand_accent(inputs)
});